export default "__VITE_ASSET__BH68Uza1__"